import api from "./api";
import Table from "@/model/table";

class TableApi extends api {
  constructor() {
    super();
    this.setup();
  }

  async getCurrently() {
    const response = await this.getHttp().get<any>('tables');
    return new Table(response.data.data)
  }
}

export default new TableApi();
